import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: process.env.REACT_APP_KEYCLOAK_URL || 'https://auth.flugsportzentrum.at',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'fzt',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'zuep',
});

export default keycloak;
